import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import {
  SiaCacheDatabaseService,
  SiaNewRouterService,
  SiaSessionService,
  SiaTokenStoreService,
} from '@sia/shared';
import { Subscription, timer } from 'rxjs';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'lib-auth-logout',
  templateUrl: './auth-logout.component.html',
  styleUrls: ['./auth-logout.component.css'],
  standalone: true,
})
export class AuthLogoutComponent implements OnInit, OnDestroy {
  cacheDatabaseService = inject(SiaCacheDatabaseService);
  siaSessionService = inject(SiaSessionService);
  routerService = inject(SiaNewRouterService);
  tokenStore = inject(SiaTokenStoreService);
  authService = inject(AuthService);

  refreshSub: Subscription = new Subscription();
  timerObservable = timer(0, 15000);
  timerWorking = false;

  async performDisconnect() {
    this.cacheDatabaseService.clearAllUserMenu();
    await this.routerService.logout();
  }

  async ngOnInit() {
    try {
      const done = await this.authService.logout();
      if (done) {
        await this.performDisconnect();
      }
    } catch (err) {
      console.error(err);
      this.startRetryTimer();
    }
  }

  ngOnDestroy(): void {
    this.stopRetryTimer();
    if (this.refreshSub) this.refreshSub.unsubscribe();
  }

  private startRetryTimer() {
    if (this.timerWorking) {
      return;
    }
    this.timerWorking = true;
    if (this.refreshSub) {
      this.refreshSub.unsubscribe();
    }
    this.refreshSub = this.timerObservable.subscribe(async () => {
      const done = await this.authService.logout();
      if (done) {
        this.stopRetryTimer();
        await this.performDisconnect();
      }
    });
  }

  private stopRetryTimer() {
    this.timerWorking = false;
    if (this.refreshSub) {
      this.refreshSub.unsubscribe();
    }
  }
}
